<template>
  <div class="task-d">
    <form @submit.prevent="onSubmitForm">
      <div class="input-field question" :class="{ mobile: isMobile }">
        <div v-if="step == 0">
          <div v-if="isMobile" class="tw-mb-[7px] tw-min-h-[31px]">
            {{ inputValue }}
          </div>
          <div v-else>
            <input
              v-model="inputValue"
              ref="inputField"
              autocomplete="off"
              autocorrect="off"
              autocapitalize="off"
              spellcheck="false"
              class="tw-border-[3px] tw-border-solid tw-border-primary tw-pt-[14px] 
                tw-pb-[8px] tw-px-[10px] tw-mb-[30px] tw-w-[400px] 
                tw-overflow-hidden tw-text-nowrap tw-text-primary 
                tw-bg-primaryvlt active:tw-outline-none focus-visible:tw-outline-none
                tw-rounded-xl"
            />
          </div>
          <button type="submit" class="sf-btn-primary">Check</button>
          <mobile-keyboard v-model="inputValue" v-if="isMobile" />
        </div>
        <div v-else class="result">
          <div class="tw-inline-block">
            {{ inputValue }}
          </div>
          <div class="tw-inline-block tw-relative tw-top-0 tw-left-0">
            <ResultMark
              :result="result > 0"
              rightClassName="tw-inline"
              wrongClassName="tw-inline"
            />
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import isMobileDevice from "@/func/general/isMobileDevice";

import ResultMark from "./ResultMark.vue";
import MobileKeyboard from "./MobileKeyboard.vue";
import {
  sfActivityCurrentWord,
  sfActivityNewAttempt,
} from "@/state/sfActivityState";

export default defineComponent({
  components: { ResultMark, MobileKeyboard },
  emits: ["completed", "tryagain"],
  data: function () {
    return {
      step: 0,
      result: 0,
      inputValue: "",
      isMobile: false,
    };
  },
  mounted: function () {
    this.isMobile = isMobileDevice();
    if (!this.isMobile) {
      (this.$refs.inputField as HTMLElement).focus();
    }
  },
  watch: {
    step: function (a) {
      if (a == 0) {
        this.$nextTick(() => {
          if (!this.isMobile) {
            (this.$refs.inputField as HTMLElement).focus();
          }
        });
      }
    },
  },
  methods: {
    onSubmitForm() {
      if (this.inputValue.trim() == "") {
        return;
      }
      let currentWord = sfActivityCurrentWord.value;
      if (!currentWord) {
        return;
      }
      this.result =
        currentWord.value.toLowerCase() == this.inputValue.trim().toLowerCase()
          ? 1
          : -1;
      const attemptCount = sfActivityNewAttempt({
        wordId: currentWord.id,
        attempt: {
          input: this.inputValue,
          is_correct: this.result > 0,
          test_time: 0,
        },
      });
      this.step = 1;
      setTimeout(() => {
        this.inputValue = "";
        this.step = 0;
        if (this.result > 0 || attemptCount > 2) {
          this.$emit("completed");
        } else {
          this.$emit("tryagain");
        }
      }, 1000);
    },
  },
});
</script>
